var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('actions-toolbar'),_vm._v(" "),_c('v-divider'),_c('conversation-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }